module.exports = __webpack_public_path__ + "school/img/ke.e6b539d3.jpg";